import IS_EFAS from '../../../components/sitebase/Environment.ts';
import { getCSRFToken } from '../../../components/sitebase/components/CookieHelper.ts';

export class MapSettingsService {
    private token: string | undefined;

    constructor(username: string | undefined) {
        this.token = username;
    }

    async updateUserWebSettings(value: { [key: string]: unknown }): Promise<void> {
        if (IS_EFAS && !this.token) {
            // anonymous user, nothing to save. GLOFAS doesn't use a token for the requests
            // instead it has the session cookie from the django authentication
            return;
        }

        const csrf = !IS_EFAS ? { 'X-CSRFToken': getCSRFToken() } : null;

        try {
            const response = await fetch("/api/user-web-settings/", {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    ...csrf
                },
                body: JSON.stringify(value)
            });

            if (!response.ok) {
                console.error("Failed to save user web settings", response);
            }
        } catch (e) {
            console.error("Failed to save user web settings", e);
        }
    }
}
